<template>
  <v-container>
    <v-text-field
      prefix="Valor actual:"
      class="ml-3 mr-3"
      v-model.number="selectedItem.customized.value"
      single-line
      disabled
      type="number"
    />

    <v-text-field
      prefix="Valor máximo:"
      class="ml-3 mr-3"
      v-model.number="selectedItem.customized.maximum_value"
      single-line
      type="number"
      @click="updateEditing(true)"
      @keypress="isNumber($event)"
      :min="selectedItem.customized.value || 0"
    />

    <v-text-field
      prefix="Dirección PLC:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.address"
      single-line
      clearable
      :clear-icon-cb="selectedItem.customized.address == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "KoioteTankCanvasProperties",

  computed: {
    ...mapState(["selectedItem"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),

    isNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        if (keyCode !== 46) {
          $event.preventDefault();
          return false;
        }
      }
    },
  },
};
</script>
